<template>
  <div>
    <van-nav-bar
      title="修改密码"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
    />
    <van-form validate-first @submit="handleRepwdClient">
      <van-col :span="24" style="text-align: center;">
        <h4>{{ userInfo.mobile }}</h4>
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.old_password" type="password" size="large" label="原密码"
                    minlength="6" :rules="[{ validator: validPwd, message: '您输入的原密码有误' }]"
        />
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.password" type="password" size="large" label="新密码"
                    minlength="6" :rules="[{ validator: validNewPwd, message: '新密码不能少于6位' }]"
        />
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.confirm_password" type="password" size="large" label="确认新密码"
                    minlength="6" :rules="[{ validator: validConfirmPwd, message: '您两次输入的新密码不一致' }]"
        />
      </van-col>
      <van-col :span="22" :offset="1">
        <br>
        <base-button size="large" native-type="submit" :round="true">修 改</base-button>
      </van-col>
      <van-col :span="24" style="text-align: center;">
        <br>
        <div style="color: #ccc; font-size: 0.8rem;">
          如您在御茶膳房登记的手机号有变更，请及时联系客服人员！
        </div>
      </van-col>
    </van-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
import { rePasswordOfClientTerm } from '@/api/settings/client'
export default {
  data() {
    return {
      form: {
        mobile: '',
        old_password: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  mounted() {
    if (!this.userInfo || !this.userInfo.id) {
      this.error('请先登录')
      this.$router.push('/clogin')
      return
    }
    this.form.mobile = this.userInfo.mobile
  },
  methods: {
    validPwd(val) {
      return String(val).length >= 6 && md5(val) === this.userInfo.password
    },
    validNewPwd(val) {
      return String(val).length >= 6
    },
    validConfirmPwd(val) {
      return String(val) === this.form.password
    },
    handleRepwdClient() {
      rePasswordOfClientTerm(this.form).then(resp => {
        this.success('修改密码成功，请您重新登录')
        this.$router.push('/clogin')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/client/client-repwd.vue